<template>
    <div>
        <div class="d-flex mb-3">
            <h4>Anexos - {{ parcelamento.descricao }}</h4>
        </div>
        <app-tabela
            idTabela="tblAnexos"
            :itens="parcelamento.documentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <b-button class="ml-3" variant="danger" @click="$emit('voltarParaParcelamentos')">
                        <span>
                            <i class="fa fa-history mr-2"></i> Retornar para os Parcelamentos
                        </span>
                    </b-button>
                    <btn-inserir
                        :parcelamento="parcelamento"
                        @obterAnexosAtualizados="obterAnexos()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-download
                    :anexo="data"
                    :parcelamento="parcelamento"
                ></btn-download>
                <btn-excluir
                    :anexo="data"
                    @obterAnexosAtualizados="obterAnexos()"
                ></btn-excluir>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ParcelamentoServicos from '../ParcelamentoServicos';
import BtnInserir from './BtnInserirAnexoParcelamento'
import BtnExcluir from './BtnExcluirAnexoParcelamento'
import BtnDownload from './BtnDownloadAnexoParcelamento';

export default {
    components: {
        BtnInserir,
        BtnDownload,
        BtnExcluir,
    },
    props: {
        parcelamento: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'documento',
                    label: 'Anexo',
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterAnexos() {
            let anexoDto = {
                idContrato: this.$route.params.contratoId,
                idInvestimentoPrevistoContrato: this.parcelamento.idInvestimentoPrevistoContrato,
                idParcela: this.parcelamento.idParcelaInvestimentoPrevistoContrato,
                // idDocumento: this.anexo.idDocumentoParcelaInvestimentoPrevistoContrato
            }
            this.$store.dispatch('addRequest')
            ParcelamentoServicos.obterAnexos(anexoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.parcelamento.documentos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os anexos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
    
    created() {},

    computed: {},

    watch: {}
}
</script>
